import type { SingleBillPayload } from '@ctct/infrastructure-layer';
import { bpConsoleApi, myAccountApi } from '@ctct/infrastructure-layer';

import type { BillingInfoRequest } from './schemas';
import {
  CountriesResponseSchema,
  BillingInfoResponseSchema,
  BillingAccountResponseSchema,
  SingleBillResponseSchema,
  PartnerResponseSchema,
} from './schemas';
import { BillingAccount, BillingInfo, Countries, Partner, SingleBill } from '../../value-objects';
import { zodService } from '../ZodService';

class BillingInfoRepo {
  public async getAllCountries() {
    const response = await myAccountApi.getCountries();

    const data = zodService.safeParse(CountriesResponseSchema, response.data);

    const countriesVO = new Countries(data.countries);

    return countriesVO;
  }

  public async getBillingInfo() {
    const response = await myAccountApi.getBillingInfo();

    return this.createBillingInfo(response.data);
  }

  public async updateBillingInfo({ customer_info, payment_info }: BillingInfoRequest) {
    const response = await myAccountApi.putBillingInfo({
      customer_info,
      payment_info,
    });

    return this.createBillingInfo(response.data);
  }

  private createBillingInfo(apiResponse: unknown) {
    const data = zodService.safeParse(BillingInfoResponseSchema, apiResponse);

    const billingInfoVO = new BillingInfo(data);

    return billingInfoVO;
  }

  public async getBillingAccount() {
    const response = await myAccountApi.getBillingAccount();

    const data = zodService.safeParse(BillingAccountResponseSchema, response.data);

    const billingAccountVO = new BillingAccount(data);

    return billingAccountVO;
  }

  public async getSingleBill() {
    const response = await bpConsoleApi.getSingleBill();

    const data = zodService.safeParse(SingleBillResponseSchema, response.data);

    const singleBillVO = new SingleBill(data);

    return singleBillVO;
  }

  public async createSingleBill(body: SingleBillPayload) {
    const response = await bpConsoleApi.postSingleBill(body);

    return response.data;
  }

  public async updateSingleBill(body: SingleBillPayload) {
    const response = await bpConsoleApi.putSingleBill(body);

    return response.data;
  }

  public async getPartner() {
    const response = await bpConsoleApi.getPartner();

    const data = zodService.safeParse(PartnerResponseSchema, response.data);

    const partner = new Partner(data);

    return partner;
  }
}

export const billingInfoRepo = new BillingInfoRepo();
